import { css } from '@emotion/react'
import custom from 'shared/styles/custom.styles'

const styles = {
    flexJustityAlignCenter: css`
        display: flex;
        flex-grow: 1;
        align-items: center;
        justify-content: center;
    `,
    dashBoardRoot: css` padding: 30px 90px `,
    fullContainer: css`
        width: 100%;
        height: 100%;
    `,
    dialogActionsRoot: css`
        justify-content: center;
        padding-top: 20px;
        padding-bottom: 20px;
    `,
    stepsPictureButton: css`
      margin: 0 30px;
      width: auto !important;
      padding: 0 40px;
      ${custom.button};
    `,
}

export default styles
